import type { Filters } from './api/schema'

export const filters = { Sector: undefined, State: undefined, City: undefined }

export const DEFAULT_FILTER_OPTIONS: Filters = {
  sectors: [],
  states: [],
  cities: [],
  products: [],
  exclusions: [],
  adjustments: [],
  adjustment_percent_min: null,
  adjustment_percent_max: null,
}
